// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__Maa8a","uploader":"styles_uploader__hGBR5","leftTable":"styles_left-table__MwWt7"};